export const ACTIVITY_CATEGORY_LABELS = {
  account: "Account",
  subscription: "Subscription",
  renewal: "Renewal",
  cancellation: "Cancellation",
  customisation: "Customisation",
  diet: "Diet Preference",
  profile: "Profile",
  holiday: "Holiday",
  meal_count: "Meal Update",
  other: "Other",
};

export const ACTIVITY_CATEGORY_COLORS = {
  account: "bg-blue-100 text-blue-700",
  subscription: "bg-green-100 text-green-700",
  renewal: "bg-indigo-100 text-indigo-700",
  cancellation: "bg-red-100 text-red-700",
  customisation: "bg-purple-100 text-purple-700",
  diet: "bg-amber-100 text-amber-700",
  profile: "bg-indigo-100 text-indigo-700",
  holiday: "bg-orange-100 text-orange-700",
  meal_count: "bg-teal-100 text-teal-700",
  other: "bg-gray-100 text-gray-700",
};

export const ACTIVITY_CATEGORIES = Object.keys(ACTIVITY_CATEGORY_LABELS);
